import { render, staticRenderFns } from "./ListagemUnidadesNegocio.vue?vue&type=template&id=035242fe&"
import script from "./ListagemUnidadesNegocio.vue?vue&type=script&lang=js&"
export * from "./ListagemUnidadesNegocio.vue?vue&type=script&lang=js&"
import style0 from "./ListagemUnidadesNegocio.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports